// src/components/BarChart.js
import React, { useState } from 'react';
import { Chart } from 'react-google-charts';
import { useEffect } from 'react';
import api from '../../../services/api';
import { vhostV1 } from '../../funcoes';
import BuscaVazaia from '../buscavazia/buscaVazia';




const ColumnChart = ({finalizadoraVenda}) => {
  // Transformar o array de objetos em um formato que o Google Charts entende

  const [dataAtual, setDataAtual] = useState(new Date());  
  finalizadoraVenda = Array.isArray(finalizadoraVenda) ? finalizadoraVenda : [];

let config = {
    headers: {
       'Authorization': localStorage.getItem("token")
       }
    }



  const data = [
    ['Descrição', 'R$'], // Cabeçalhos das colunas
    ...finalizadoraVenda.map(item => [item.FINALIZADORA ?? 'N/A', item.VALOR_FINAL ?? 0]) // Dados do gráfico
  ];

  // Opções do gráfico
  const options = {
    title: 'Gráfico de vendas(R$)',
    legend: { position: 'none' },
    chartArea: { width: '80%' } // Ocultar legenda
  };

  return (
    <div>
      <Chart
        chartType="ColumnChart"
        width="100%"
        height="190px"
        data={data}
        options={options}
      />
    </div>
  );
};

export default ColumnChart;
